<template>
  <div>
    <section class="container" style="margin: 2% auto">
      <div class="columns">
        <div class="column  is-one-quarter">
          <div class="card color_one">
            <div class="card-content">
              <div class="content">
                <h1 class="small_text"> Requests By Equipment Type</h1>
                <h1 class="small_text" v-for="equipmentType of equipmentTypes" :key="equipmentType"> {{equipmentType}} : <span class="big_number">{{stats.equipmentRequestsByEquipmentType[equipmentType]}} </span></h1>
              </div>
            </div>
          </div>

        </div>
        <div class="column  is-one-quarter">
          <div class="card color_two">
            <div class="card-content">
              <div class="content">
                <h1 class="small_text"> Requests By Status</h1>
                <h1 class="small_text" v-for="status of statuses" :key="status"> {{status}} : <span class="big_number"> {{ stats.equipmentRequestsByStatus[status.toLowerCase()]}} </span>
                </h1>
              </div>
            </div>
          </div>

        </div>
        <div class="column  is-one-quarter">
          <div class="card color_three">
            <div class="card-content">
              <div class="content">
                <h1 class="small_text"> Total Month Accepted Requests : <span class="big_number"> </span> {{ stats.totalEquipmentRequestsAcceptedThisMonth }}
                </h1>
              </div>
            </div>
          </div>

        </div>
        <div class="column  is-one-quarter">
          <div class="card color_four">
            <div class="card-content">
              <div class="content">
                <h1 class="small_text"> Total Accepted Requests : <span class="big_number"> {{stats.totalEquipmentRequestsAcceptedSinceLaunch }}
                  </span></h1>
              </div>
            </div>
          </div>

        </div>
      </div>

    </section>
  </div>
</template>

<script>
  import OrderStats from '@/components/EquipmentRequests/Stats';
  import {ucFirst} from '@/helpers';
  export default {
    name: "Dashboard",
    components: {
      OrderStats
    },
    computed: {
      statuses() {
        return Object.keys(this.stats.equipmentRequestsByStatus ? this.stats.equipmentRequestsByStatus: []).map(eRBS => ucFirst(eRBS))
      },
      equipmentTypes() {
        return Object.keys(this.stats.equipmentRequestsByEquipmentType ? this.stats.equipmentRequestsByEquipmentType : []).map(eRBET => ucFirst(eRBET));
      }
    },
    data() {
      return {
        stats: {
          equipmentRequestsByEquipmentType: {},
          equipmentRequestsByStatus: {},
          totalEquipmentRequestsAcceptedThisMonth: 0,
          totalEquipmentRequestsAcceptedSinceLaunch: 0
        }
      }
    },
    created() {
      this.getStats()
    },
    methods: {
      getStats() {
        this.stats = {};
        this.isLoading = true;
        this.$store.dispatch('getStats').then(stats => {
          this.isLoading = false;
          this.stats = stats;
        }).catch(e => {
          console.log(`Exception when getting stats, e:${e}`);
          this.isLoading = false;
        })
      }
    }
  }

</script>

<style>
  .card {
    font-size: 50%;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
    transition: 0.3s;
    border-radius: 5px;
    margin: 2px;
  }

  .color_one {
    background-color: #ce93d8;
  }

  .color_two {
    background-color: #90caf9;
  }

  .color_three {
    background-color: #cfd8dc;

  }

  .color_four {
    background-color: #c5e1a5;
  }

  .small_text {
    font-size: 50%;
  }

  .big_number {
    font-family: monospace;
    font-weight: bolder;
    font-size: 150%;
  }

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Home.vue